import {API_STRATEGIES, MARKER_BATCH_SIZE} from "@/utils/mapUtil/constants";
import {addMarkers} from "@/utils/mapUtil/funcs";

/**
 * 分页批量加载所有markers
 * @param {*} type   数据类型  1-托管服务商,2-农机服务商,3-托管地块,4-农资商.
 *                   请使用./constants.js
 * @param {*} params 后端接口需要的参数
 * @param {*} layer   地图图层
 * @returns
 */
export async function loadMarkersBatch(type, params, layer) {
  if (!params || !type) return;

  if (!API_STRATEGIES[type]) {
    console.error(`${type} 错误`);
    return
  }

  try {
    let firstPage, sumCount, totalPage
    const strategy = API_STRATEGIES[type];
    firstPage = await strategy.loadPage(params);
    sumCount = strategy.getTotal(firstPage)
    totalPage = Math.ceil(sumCount / MARKER_BATCH_SIZE);

    const resData = strategy.getData(firstPage)

    // 处理并添加标记到地图
    addMarkers(type, resData, layer);

    // 使用setTimeout异步加载剩余页数据
    for (let i = 2; i <= totalPage; i++) {
      setTimeout(async () => {
        params.current = i
        const page = await strategy.loadPage(params);
        const data = strategy.getData(page)
        addMarkers(type, data, layer);
      }, (i - 1) * 50); // 每页间隔50ms加载
    }
  } catch (error) {
    console.error("数据获取失败:", error);
  }
}
